import React from 'react';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: '40px 15px 44px',
    marginTop: 20,
    backgroundColor: '#FFDCBC',
    [theme.breakpoints.down('sm')]: {
      padding: '32px 32px 40px',
    },
  },
  title: {
    fontSize: 24,
    fontWeight: 700,
    fontStyle: 'italic',
    maxWidth: 500,
    textAlign: 'center',
    margin: '0 auto',
    [theme.breakpoints.down('sm')]: {
      fontSize: 20,
    },
  },
  text: {
    maxWidth: 665,
    fontSize: 16,
    margin: '40px auto 0',
  },
}));

function SubHero() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.title}>
        Whether you’re conscious of it or not, you paraphrase every day ━ we all do.
      </div>
      <div className={classes.text}>
        It’s a skill that we see in professional settings, on TV, and in literature. Paraphrasing is
        an essential part of communication, but what exactly is it? And how can you become
        proficient in it? Fear not; we’re about to walk you through it all.
      </div>
    </div>
  );
}

export default SubHero;
